<template>
    <div class="farm-card" :class="mode == 'dark' ? 'dark' : 'light'">
        <div class="uk-card uk-box-shadow-medium">
            
            <div class="uk-card-header uk-grid-collapse uk-padding" uk-grid>
                <div class="uk-width-auto uk-flex uk-flex-middle">
                    <img :src="cryptoLogo" alt="Crypto logo" width="64" height="64" class="uk-margin-right">
                </div>
                <div class="uk-width-expand">
                    <h3 class="uk-card-title uk-margin-remove-bottom">{{ farmTitle }}<span class="uk-margin-left">APY {{ farmAPY }}%</span></h3>
                    <div class="uk-flex uk-flex-middle">
                        <p class="uk-margin-small-bottom uk-margin-right">Powered by:</p>
                        <img class="uk-margin-small-bottom" v-for="lp in lps" :key="lp" :src="lp" alt="Provider" height="32" width="32">
                    </div>
                </div>
            </div>

            <div class="uk-card-body uk-flex uk-flex-column uk-padding-remove-top">
                <h4>Your funds: {{ this.funds }}</h4>
                <div class="uk-flex">
                    <input type="number" class="uk-input uk-margin-small-right" placeholder="Deposit amount">
                    <button type="button" class="uk-button">MAX</button>
                </div>
            </div>

            <div class="uk-card-footer uk-flex uk-padding-remove-top">
                <button id="deposit-button" class="uk-button uk-margin-right" type="button">Deposit</button>
                <button id="cooler-deposit-button" class="uk-button" type="button">Deposit &amp; Stake</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FarmCard',
    props: {
        mode: String,
        cryptoLogo: String,
        farmTitle: String,
        farmAPY: Number,
        lps: Array
    },
    data: function() {
        return {
            funds: Math.random() * 100
        }
    }
}
</script>

<style lang="less" scoped>
    @import "../../dark-components/farm-card.less";

    .uk-card {
        border-radius: .5em;
        margin-bottom: 1em;

        .uk-card-header {
            padding-top: .5em;

            h3 {
                font-family: 'Lato';
                font-weight: 700;
                .fluid-font(1.2, 25, 320, 3840);
                color: @text-color;

                span {
                    .fluid-font(.8, 1, 320, 3840);
                }
            }

            p {
                font-family: 'Lato';
                .fluid-font(1, 15, 320, 3840);
            }
        }

        .uk-card-body {
            h4 {
                font-family: 'Lato';
                color: @text-color;
                .fluid-font(1.2, 5, 320, 3840);
            }

            button {
                border-radius: .15em;
                background-color: @brand-color;
                color: lighten(@champagne-pink, 15%);
                font-weight: 700;
                font-family: 'Lato';
                .fluid-font(1, 5, 320, 3840);
            }

            input {
                border-radius: .2em;
                border: 2px @salmon-pink solid;
                font-family: 'Lato';
                font-weight: 700;
                color: @text-color;
                .fluid-font(1, 5, 320, 3840)
            }
        }

        .uk-card-footer {
            button {
                font-family: 'Lato';
                font-weight: 700;
                .fluid-font(1, 5, 320, 3840);
                color: @rubine-red;
                border: @brand-color 2px solid;
                border-radius: .2em;
                background-color: transparent;
                transition: all .3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
            }

            button:hover {
                color: lighten(@champagne-pink, 15%);
                background-color: @rubine-red;
                transition: all .3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
            }
        }

        @media only screen and (max-width: 1100px) {
            .uk-card-footer {
                flex-direction: column;
                align-items: center;

                button {
                    width: 100%;
                    margin-bottom: 1em;
                    margin-right: 0 !important;
                }
            }
        }

         @media only screen and (max-width: 960px) and (min-width: 433px) {
            .uk-card-footer {
                button {
                    width: 75%;
                }
            }
        }
    }

    
</style>